import { Component, StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.js";
import "./payroll/styles/index.css";
import "./styles.css";
import "./fiori-production.css";

class SafeErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  public override state = { failed: false };
  public static getDerivedStateFromError() {
    return { failed: true };
  }
  public override render() {
    return this.state.failed ? (
      <main className="center" role="alert">
        <h1>PayDay could not load this view</h1>
        <p>
          Refresh the page. Support can use the browser reference if the problem
          continues.
        </p>
      </main>
    ) : (
      this.props.children
    );
  }
}

const root = document.getElementById("root");
if (root === null) throw new Error("PayDay root is missing");

async function bootstrap() {
  // Im Dev-Server (nicht im Produktions-Build) MSW starten, damit die GUI
  // ohne echtes Backend läuft und Live-Änderungen per HMR sichtbar sind.
  if (import.meta.env.DEV) {
    const { worker } = await import("./mocks/browser.js");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  if (root === null) throw new Error("PayDay root is missing");
  createRoot(root).render(
    <StrictMode>
      <SafeErrorBoundary>
        <App />
      </SafeErrorBoundary>
    </StrictMode>,
  );
}

void bootstrap();
